export default "__VITE_ASSET__CsykQoGR__"